export default __webpack_public_path__ + "media/images/mailer/wordmark-7bd00903c7f7ebf73ad17090f5db02d4.png";